import { parseISO } from "date-fns";
import { Gender, Team, TeamRequest, TeamResponse, TeamStatus } from "@/common/models/team";
import axios from "@/common/services/axios";
import { TEAMS_ENDPOINT } from "@/common/constants";

const processTeam = (raw: TeamResponse): Team => ({
  id: raw.id,
  name: raw.name,
  shortName: raw.short_name,
  description: raw.description,
  avatar: raw.avatar,
  category: raw.category,
  gender: raw.gender as unknown as Gender,
  status: raw.status as unknown as TeamStatus,
  created: parseISO(raw.created_at),
  updated: parseISO(raw.updated_at),
  createdBy: raw.created_by,
  updatedBy: raw.updated_by,
});

export const fetchTeams = async (): Promise<Team[]> => {
  const response = await axios.get<TeamResponse[]>(TEAMS_ENDPOINT);
  return Array.isArray(response.data) ? response.data.map(processTeam) : [];
};

export const fetchTeam = async (id: string): Promise<Team> => {
  const response = await axios.get<TeamResponse>(`${TEAMS_ENDPOINT}/${id}`);
  return processTeam(response.data);
};

export const createTeam = async (request: TeamRequest): Promise<Team> => {
  const response = await axios.post<TeamResponse>(`${TEAMS_ENDPOINT}`, request);
  return processTeam(response.data);
};

export const updateTeam = async (request: TeamRequest): Promise<Team> => {
  const response = await axios.post<TeamResponse>(`${TEAMS_ENDPOINT}/${request.id}`, request);
  return processTeam(response.data);
};
